import { render, staticRenderFns } from "./PageNav.vue?vue&type=template&id=60e3e1f0&scoped=true&"
import script from "./PageNav.vue?vue&type=script&lang=js&"
export * from "./PageNav.vue?vue&type=script&lang=js&"
import style0 from "./PageNav.vue?vue&type=style&index=0&id=60e3e1f0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e3e1f0",
  null
  
)

export default component.exports